import React, { useEffect, useContext, useState } from "react";
import "./../../../../font.css";
import { CircularProgress } from "@mui/material";
import { Translate } from "react-i18nify";

import SocketIOContext from "./../../../../contexts/Kiosk/SocketProvider/SocketIOContext";
// import SocketIOContext from "../../../contexts/Kiosk/SocketProvider/SocketIOContext";

let env = require("./../../../../env");

// Using a functional component, you must wrap it in React.forwardRef, and then forward the ref to
// the node you want to be the root of the print (usually the outer most node in the ComponentToPrint)
// https://reactjs.org/docs/refs-and-the-dom.html#refs-and-function-components
function PartnerLogo(props) {
  const { getKioskTheme } = useContext(SocketIOContext);

  const [loading, setLoading] = useState(true);
  const kioskTheme = getKioskTheme();

  return (
    <div
      id="PartnerLogo"
      style={{
        display: "flex",
        height: "auto",
        width: "auto",
        maxWidth: "100%",
        maxHeight: "100%",
        justifyContent: "left"
      }}
    >
      {kioskTheme.partneringLogoPath && loading ? (
        <div>
          <CircularProgress />
        </div>
      ) : (
        <></>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          whiteSpace: "nowrap"
          //overflow: "hidden"
        }}
      >
        {/* <div style={{ fontSize: "0.8cqw", marginBottom: "0.5vh" }}></div> */}
        <div
          style={{
            //fontSize: "1.6cqh",
            fontSize: "1.6vh",
            marginBottom: "0.5vh",
            color: kioskTheme.mainscreenTextColor
          }}
        >
          <Translate value="application.theme.partnerTitle" />
        </div>
        <img
          src={
            env.REACT_APP_API_ENDPOINT +
            "/kiosk/getImage/PartneringLogo" +
            "?t=" +
            kioskTheme.lastUpdatedImgETag
          }
          onLoad={() => setLoading(false)}
          // objectFit="contain"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain"
          }}
          alt="Partner Logo"
        />
      </div>
    </div>
  );
}

export default PartnerLogo;
